export enum MetricFilters {
  Availability = 'availability',
  Utilization = 'utilization',
  MatchRate = 'matchRate',
}
